module.exports = __webpack_public_path__ + "media/images/result_sets/circles/1r2r7r4n-0493a50d4d6cdec9eed13765633b6c77.svg";